import { Component } from '@verndale/core';
import { calculateLeftBorderHeight } from '../utils';
import { customEvents } from '../helpers/constants';

class InteriorHero extends Component {
  setupDefaults() {
    this.setupLeftBorder();
    this.watchMainElement();
  }

  addListeners() {
    window.addEventListener(customEvents.leftBorderResizeTrigger, () => {
      calculateLeftBorderHeight(
        document.querySelector('.interior-hero__left-border')
      );
    });
  }

  watchMainElement() {
    const resizeObserver = new ResizeObserver(entries => {
      calculateLeftBorderHeight(
        document.querySelector('.interior-hero__left-border')
      );
    });

    resizeObserver.observe(document.querySelector('body, main'));
  }

  setupLeftBorder() {
    const leftBorder = document.createElement('div');
    console.log('holaaaa', leftBorder);
    leftBorder.classList.add('interior-hero__left-border');
    this.el.append(leftBorder);
    calculateLeftBorderHeight(leftBorder);
  }
}

export default InteriorHero;
